var classes = {"carouselControl":"_6AS-9"};

export { classes as default };
